import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Check, Download } from 'lucide-react';
export function WhatYouGetSection() {
  const items = ['PDF principal: Calendario de 14 días + 30 recetas "Zero‑Bloat" con cantidades reales', 'Guía de porciones + Plantilla Zero‑Bloat (para crear los tuyos)', 'Listas de compra Semana 1 y Semana 2', 'Versiones: sin lácteos / alta proteína / baja azúcar', 'Protocolo "si me hincha" (ajuste en 72 horas)', 'Checklist diario + FAQ'];
  const bonuses = ['BONUS 1 (PDF): Ruta Oficina (7 días) — hinchazón "de escritorio"', 'BONUS 2 (PDF): Ruta Cero Tiempo (Batch 10 min) — semanas con prisa', 'BONUS 3 (PDF): Ruta Antojos 18:00 (7 días) — picoteo y dulce por la tarde'];
  return <Section background="white" data-id="element-121">
      <div className="text-center mb-8 md:mb-12" data-id="element-122">
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26] mb-3 md:mb-4" data-id="element-123">
          Lo que compras hoy (descarga inmediata)
        </h2>
        <p className="text-[#6B6560]" data-id="element-124">
          Todo lo que necesitas para empezar mañana mismo
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-[#F0F4EE] rounded-2xl p-6 flex flex-col items-center" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/r6zdbWzKrqLQ23SEnXG5aV/mokup_smoothies1.png" alt="Plan Barriga Desinflamada 14 Días — PDF principal" className="w-full max-w-xs rounded-xl shadow-lg mb-4" data-id="element-127" />
          <p className="text-sm font-semibold text-[#5B7C5B]" data-id="element-128">
            PDF Principal — Plan 14 Días
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="bg-[#FAF7F2] rounded-2xl p-6 flex flex-col items-center border border-[#E8E2DA]" data-id="element-129">
          <img src="https://cdn.magicpatterns.com/uploads/h28aS12FoCd8QJNrUw8dQG/mokup_smoothies_bonus.png" alt="Pack de 3 Bonus — Ruta Oficina, Ruta Cero Tiempo, Ruta Antojos 18:00" className="w-full max-w-xs rounded-xl shadow-lg mb-4" data-id="element-130" />
          <p className="text-sm font-semibold text-[#D4836B]" data-id="element-131">
            Pack de 3 Bonus Incluidos
          </p>
        </motion.div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-start" data-id="element-132">
        <div className="bg-[#FAF7F2] p-5 md:p-8 rounded-2xl border border-[#E8E2DA]" data-id="element-133">
          <h3 className="text-lg md:text-xl font-serif font-bold text-[#5B7C5B] mb-4 md:mb-6 flex items-center" data-id="element-134">
            <Download className="h-5 w-5 mr-2" data-id="element-135" />
            El Plan Completo
          </h3>
          <ul className="space-y-3 md:space-y-4" data-id="element-136">
            {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-137">
                <Check className="h-5 w-5 text-[#D4836B] mt-0.5 mr-3 flex-shrink-0" data-id="element-138" />
                <span className="text-[#2D2A26]" data-id="element-139">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-[#F0F4EE] p-5 md:p-8 rounded-2xl border border-[#5B7C5B]/20" data-id="element-140">
          <h3 className="text-lg md:text-xl font-serif font-bold text-[#5B7C5B] mb-4 md:mb-6" data-id="element-141">
            Incluye 3 Bonus Exclusivos
          </h3>
          <ul className="space-y-3 md:space-y-4" data-id="element-142">
            {bonuses.map((bonus, index) => <li key={index} className="flex items-start bg-white p-3 md:p-4 rounded-lg shadow-sm" data-id="element-143">
                <span className="text-[#D4836B] font-bold mr-3 text-lg" data-id="element-144">
                  +{index + 1}
                </span>
                <span className="text-[#2D2A26] font-medium" data-id="element-145">{bonus}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}